<template>
  <div class="portal-page">
    <header class="portal-header">
      <div class="brand">
        <h1>信息快速收集<span>（测试）</span></h1>
      </div>
      <p class="subtitle">统一入口 · 现场信息快速采集上报</p>
    </header>

    <main class="portal-main">
      <div class="entry-grid">
        <a
          v-for="e in entries"
          :key="e.id"
          class="entry-card"
          :href="e.url"
          :target="e.internal ? '' : '_blank'"
          :rel="e.internal ? '' : 'noopener'"
        >
          <div class="card-icon">
            <el-icon :size="26"><component :is="iconMap[e.icon]" /></el-icon>
          </div>
          <div class="card-body">
            <div class="card-title">{{ e.name }}<span class="status-dot">在线</span></div>
            <p class="card-desc">{{ e.desc }}</p>
          </div>
          <div class="card-enter">进入</div>
        </a>
      </div>
      <div class="entry-count">共 {{ entries.length }} 个入口 · <a href="https://gitee.com/tuzi-dx" target="_blank" rel="noopener">Gitee 平台</a></div>
    </main>
  </div>
</template>

<script setup>
import { Warning, Camera, MapLocation, Monitor } from '@element-plus/icons-vue'

const iconMap = { warning: Warning, camera: Camera, map: MapLocation, shield: Monitor }

// 与 portal/entries.js（原 home-page 仓库）保持一致；信息收集为本站内子路径 #/gather
const entries = [
  {
    id: 'mob_sec_risk_report',
    name: '安全隐患上报',
    desc: '手机拍照上报现场安全隐患（部门 / 区域 / 类型 / 描述 / 照片）',
    icon: 'warning',
    url: 'https://sec-risk-report.tuzi-dx.online',
    internal: false
  },
  {
    id: 'information_gathering',
    name: '信息收集',
    desc: '信息快速收集：拍照 / 录像实时上传，生成唯一记录码（备注 / 上传人）',
    icon: 'camera',
    url: '#/gather',
    internal: true
  },
  {
    id: 'safety_inspection',
    name: '安全巡检管理',
    desc: '手机扫码巡检：日常 / 特别安排 / 节假日 / 长假，异常隐患闭环管理',
    icon: 'map',
    url: 'https://safety-inspection.tuzi-dx.online',
    internal: false
  },
  {
    id: 'mobile_sec_patrol',
    name: '移动端安全巡检平台',
    desc: '电脑端安全巡检管理后台的移动版：总览 / 巡检计划 / 巡检安排 / 值班领导 / 异常报告 / 巡检记录 / 隐患闭环',
    icon: 'shield',
    url: 'https://mob-sec-patrol.tuzi-dx.online',
    internal: false
  }
]
</script>

<style scoped>
.portal-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.portal-header {
  text-align: center;
  padding: 44px 20px 26px;
  color: #fff;
}

.portal-header h1 {
  font-size: 26px;
  font-weight: 700;
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
}

.portal-header h1 span {
  font-size: 15px;
  font-weight: 400;
  opacity: 0.9;
}

.subtitle {
  margin-top: 8px;
  font-size: 14px;
  opacity: 0.85;
}

.portal-main {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 16px 32px;
}

.entry-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 14px;
}

.entry-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 14px;
  padding: 16px 14px;
  text-decoration: none;
  color: #303133;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.15s, box-shadow 0.15s;
}

.entry-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
}

.card-icon {
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.card-body {
  flex: 1;
  min-width: 0;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #67c23a;
  display: inline-block;
}

.card-desc {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-enter {
  flex-shrink: 0;
  font-size: 13px;
  color: #667eea;
  font-weight: 600;
  white-space: nowrap;
}

.entry-count {
  margin-top: 18px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  opacity: 0.85;
}

.entry-count a {
  color: #fff;
}
</style>
